
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { Toast } from 'vant'
import useOpenInfo from '@/hooks/openInfo'
import { ImageType, OpenAccountTypeMap } from '@/enum'
import stepPercentage from '@/utils/number'
import { openFileView, setApptitle } from '@/utils/native-app'
import { useMutation, useQuery } from '@vue/apollo-composable'
import { queryApi } from '@/graphql/query'
import * as storage from '@/utils/storage'
import { dobuleSaveDraft } from '@/graphql/mutation'

export default defineComponent({
  setup () {
    const router = useRouter()
    const {
      meta,
      openType,
      openInfo,
      step,
      title,
      saveOpenInfoOfVuex,
      saveCommonOfVuex
    } = useOpenInfo()
    const commomParams = ref()
    const isPiVerify = openInfo.value.isPiVerify
    let filelist = [
      { text: '《客户协议书》', name: 'GHSLClientAgreement(SimpChi)Nov2021.pdf' },
      { text: '《客户声明》', name: 'client_statement' },
      { text: '《风险披露声明》', name: 'risk_statement' },
      { text: '《海外账户税收合规法案声明》', name: 'fatca' },
      { text: '《金马证券收费表》', name: 'charge.url' },
      { text: '《个人资料收集声明》', name: 'personal_info' },
      { text: '《专业投资者评估及声明书》', name: 'PIAssessmentAndDeclaration.pdf' },
      { text: '《自动交换财务账户资料声明》', name: 'accinfo_statement' }
    ]
    // 获取storage中的formType,用来区分普通开户和投资移民户
    const formType = computed(() => storage.get('formType'))

    const files = computed(() => {
      if (isPiVerify === 0) {
        filelist = filelist.filter(item => item.text !== '《专业投资者评估及声明书》')
      }
      return filelist
    })
    const agreeOpenFile = ref(false)
    const showPdf = (name: string, text: string) => {
      const url = `${process.env.VUE_APP_H5_STATIC_PAGE_URL + '/static_pages/pdf/' + name}`
      const title = text
      const params = {
        fileType: 'pdf',
        fileUrl: url,
        title
      }
      openFileView(params)
    }
    const toFile = (name: string, text: string) => {
      // 收费表格单独请求帮助中心链接
      if (name === 'charge.url') {
        window.location.href = process.env.VUE_APP_H5_CHARGE_URL
      } else if (!name.includes('.pdf')) {
        window.location.href = `${process.env.VUE_APP_H5_STATIC_PAGE_URL + '/static_pages/' + name}.html`
      } else {
        showPdf(name, text)
      }
    }

    const signImageUrl = ref()

    // 用户信息回填
    const initData = () => {
      agreeOpenFile.value = openInfo.value?.agreeOpenFile
    }
    const isDisabled = computed(() => !(agreeOpenFile.value && signImageUrl.value))

    // 客户签名
    const signatureHandle = () => {
      router.push({ name: 'signature' })
    }

    // 保存步骤信息
    // 保存下一步调用接口
    const saveNext = () => {
      const percentage = stepPercentage(step)
      commomParams.value = {
        openType: openType.value,
        openStatus: 0,
        btnText: '继续开户',
        remark: `已完成${percentage}%，请继续完善资料`,
        step
      }

      saveClientDraft({
        param: {
          formType: formType.value,
          meta: meta.value,
          content: JSON.stringify({ agreeOpenFile: agreeOpenFile.value })
        },
        commomParams: {
          formType: formType.value,
          meta: 'open_common',
          content: JSON.stringify(commomParams.value)
        }
      })
    }
    const handleNext = () => {
      if (!signImageUrl.value) {
        Toast('请手写签名')
        return
      }
      saveNext()
    }
    // 保存步骤信息回调
    const changeAgree = () => {
      saveOpenInfoOfVuex({ info: { agreeOpenFile: agreeOpenFile.value } })
    }

    // 查询图片缓存
    const { onResult } = useQuery(queryApi.fileTempQuery, {
      params: {
        kindSource: openType.value,
        openAccountType: OpenAccountTypeMap[formType.value as string]
      }
    })
    onResult((res) => {
      const { fileTempQuery } = res.data
      if (fileTempQuery.ok) {
        const list = fileTempQuery.data.filter(
          (val: { imageType: number; idKindType: number }) =>
            val.imageType === ImageType.ACC_IMAGE_TYPE_301 && val.idKindType === openInfo.value.idKind
        )
        signImageUrl.value = list.length ? list[0].remoteUrl : ''
      }
    })

    // 存储缓存表方法
    const { mutate: saveClientDraft, onDone } = useMutation(dobuleSaveDraft)

    onDone((res) => {
      const { saveClientFormDraft, commonDraft } = res.data
      if (saveClientFormDraft.ok && commonDraft.ok) {
        saveCommonOfVuex({ info: commomParams.value })
        router.push({ name: 'transfer-step' })
      }
    })

    onMounted(() => {
      setApptitle(title)
      initData()
    })

    return {
      handleNext,
      files,
      agreeOpenFile,
      signatureHandle,
      signImageUrl,
      isDisabled,
      toFile,
      changeAgree,
      showPdf,
      isPiVerify
    }
  }
})
